import { render } from "./ReceiptPage.vue?vue&type=template&id=367b0756&ts=true"
import script from "./ReceiptPage?vue&type=script&lang=ts"
export * from "./ReceiptPage?vue&type=script&lang=ts"

import "@/views/_assets/_verticalApp.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/runner/work/xebel/xebel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__